import PropTypes from 'prop-types';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { selectPrintJob } from '../../selectors/print';
import PrintSelection from './print_dialog/print_selection.jsx';
import Preparing from './print_dialog/prepare.jsx';
import Dialog from '../dialog.jsx';

const STEPS = {
    SELECTION: 'SELECTION',
    PREPARE: 'PREPARE',
    PRINT_PREVIEW: 'PRINT_PREVIEW',
};

export default class PrintDialogUI extends React.Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        routeToContentPage: PropTypes.func.isRequired,
        selectPrintJob: PropTypes.func.isRequired,
        rootState: PropTypes.object,
        newPrintJob: PropTypes.func,
        content: PropTypes.object,
    };

    state = {
        step: STEPS.SELECTION,
    };

    componentDidUpdate(_, oldState) {
        if (
            this.state.step === STEPS.PRINT_PREVIEW &&
            this.state.step !== oldState.step
        ) {
            this.printFrame();
        }
    }

    onReady = () => {
        this.setState({
            step: STEPS.PRINT_PREVIEW,
        });
    };

    onSelectPages = pageList => {
        const { newPrintJob, params, routeToContentPage } = this.props;
        if (pageList) {
            const { content } = this.props;
            const jobId = newPrintJob(content, pageList, () =>
                routeToContentPage(params)
            );
            this.setState({
                step: STEPS.PREPARE,
                jobId,
            });
        }
    };

    onSubmit = event => {
        event.preventDefault();
        this.print();
    };

    printFrame = () => {
        const iframe = document.createElement('iframe');
        iframe.title = 'print';
        iframe.style.position = 'absolute';
        iframe.style.zIndex = '-1';
        document.body.appendChild(iframe);
        const { rootState } = this.props;
        const { jobId } = this.state;
        const job = selectPrintJob(rootState, jobId);

        const html = ReactDOMServer.renderToStaticMarkup(
            this.renderFinalImages(job)
        );

        iframe.contentDocument.write(html);

        const images = iframe.contentDocument.getElementsByTagName('img');

        Promise.all(
            // BOO! images is an HTMLCollection and not an array
            [...images].map(img => {
                return img.complete
                    ? Promise.resolve()
                    : new Promise(res => {
                          img.onload = res;
                      });
            })
        ).then(() => {
            iframe.contentWindow.focus();
            let didPrint = false;
            try {
                // IE compatibility
                didPrint = iframe.contentDocument.execCommand(
                    'print',
                    false,
                    null
                );
            } catch (e) {
                /* eslint-disable-line no-empty */
            }

            if (!didPrint) {
                iframe.contentWindow.print();
            }

            document.body.removeChild(iframe);
            this.props.routeToContentPage(this.props.params);
        });
    };

    renderFinalImages = job => {
        // YAY! Inline styles!
        const style = {
            width: '100%',
            height: 'auto',
            pageBreakInside: 'avoid',
        };
        const images = job.urls.map(url => {
            // The alt is just to prevent react-a11y from warning. The iframe is
            // invisible and isn't going to be reachable by the user.
            return (
                <img style={style} src={url} key={url} alt="Watermarked page" />
            );
        });

        return <body>{images}</body>;
    };

    render() {
        const { step, jobId } = this.state;
        const { content, params, routeToContentPage } = this.props;
        if (step === STEPS.SELECTION) {
            return (
                <PrintSelection
                    routeToContentPage={routeToContentPage}
                    params={params}
                    onSelectPages={this.onSelectPages}
                    content={content}
                />
            );
        } else if (step === STEPS.PREPARE) {
            return (
                <Preparing
                    job={this.props.selectPrintJob(jobId)}
                    onReady={this.onReady}
                />
            );
        } else if (step === STEPS.PRINT_PREVIEW) {
            return (
                <Dialog
                    focusDialog
                    underlayClickExits={false}
                    closeButton={false}
                    title="Print"
                >
                    <div className="loading-container">
                        <div className="loading-block">
                            <div className="loading">
                                <h1>Rendering pages</h1>
                                <p />
                                <span className="ball1" />
                                <span className="ball2" />
                            </div>
                        </div>
                    </div>
                </Dialog>
            );
        }

        throw new Error('Missing step: ' + step);
    }
}



// WEBPACK FOOTER //
// ./src/components/engage_reader/print_dialog.ui.jsx